module.exports = __webpack_public_path__ + "static/media/client-logo-22.04d82692.jpg";